import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk to fetch business partners
  export const fetchBusinessPartners = createAsyncThunk(
  'businessPartners/fetch',
  async (_, { rejectWithValue }) => {
      try {
      const token = localStorage.getItem('authToken');
      console.log("the token from ---->business partner--->", );
      const response = await fetch('https://onboard.rechargkit.biz/member/businessPartners', {
          headers: {
          Authorization: `Bearer ${token}`,
          },
      });
      const data = await response.json();

      if (!response.ok || data.error === 1) {
        return rejectWithValue(data.msg || 'Failed to fetch business partners');
      }

      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Something went wrong');
    }
  }
);

const businessPartnersSlice = createSlice({
  name: 'businessPartners',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusinessPartners.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBusinessPartners.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchBusinessPartners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default businessPartnersSlice.reducer;
